<template>
    <common-content-spacer v-if="ancillaryServices.length" height="large" class="ancillary-table">
        <div class="ancillary-table__values">
            <div v-for="(item, index) in checkedValues" :key="index">
                {{ item.name }}
                <common-icon name="close" size="small" @click="selectionChanged(item)"></common-icon>
            </div>
        </div>
        <common-page-header
            v-if="showHeader"
            size="medium"
            :heading="$t('pages.ancillary.ancillary_table.heading')"
        ></common-page-header>
        <div>
            <common-page-header size="small" :heading="$t('elements.home.select_tests_reminder.header')"></common-page-header>
        </div>
        <div class="ancillary-table__container">
            <div v-for="(value, i) in ancillaryServicesFiltered" :key="i" class="ancillary-table__container--wrapper">
                <common-content-spacer height="medium" class="ancillary-table__container--spacer">
                    <div class="ancillary-table__container--group">
                        <common-icon size="gigantic" :name="getAncillaryIcon(value.id)"></common-icon>
                        <p class="ancillary-table__container--group--text">{{ value.name }}</p>
                    </div>
                    <div
                        v-for="(item, index) in value.facilityServiceTypes"
                        :key="index"
                        class="ancillary-table__container--item"
                    >
                        <common-content-spacer height="medium">
                            <div class="ancillary-table__container--item--header" @click="item.expanded = !item.expanded">
                                <common-page-header size="small" :heading="item.name"></common-page-header>
                                <common-icon
                                    :class="item.expanded ? 'icon--expanded' : ''"
                                    name="menu-arrow"
                                    size="large"
                                ></common-icon>
                            </div>
                            <common-content-spacer
                                v-show="item.expanded"
                                height="medium"
                                class="ancillary-table__container--groups"
                            >
                                <text-input
                                    :placeholder="$t('pages.ancillary.ancillary_table.filter_label')"
                                    @change="filter($event, item, i, index)"
                                ></text-input>
                                <div v-for="(group, key) in item.facilityServiceTypesGroups" :key="key">
                                    <!-- id 7 is service id of radiology and its the only servide that has tests thats why we only shot its groups label -->
                                    <common-page-header
                                        v-if="item.id == 7 && !checkIfAnyTestExist(group)"
                                        size="small"
                                        :heading="group.name"
                                    ></common-page-header>
                                    <span
                                        v-for="(subGroup, keySubgroup) in group.facilityServiceTypesSubgroups"
                                        :key="keySubgroup"
                                    >
                                        <p
                                            v-for="(test, keyTest) in subGroup.facilityServiceTests"
                                            :key="keyTest"
                                            class="ancillary-table__container--item--test"
                                        >
                                            <checkbox-input
                                                :label="test.name"
                                                :value="checked(test.id)"
                                                @change="selectionChanged(test)"
                                            ></checkbox-input>
                                        </p>
                                    </span>
                                </div>
                            </common-content-spacer>
                        </common-content-spacer>
                    </div>
                </common-content-spacer>
            </div>
        </div>
        <common-buttons>
            <common-button
                :disabled="!checkedValues.length"
                :label="$t('common.microcopy.done')"
                type="primary"
                @click="saveChanges"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
    <div v-else>
        <p>{{ $t('pages.ancillary.ancillary_table.no_tests_available') }}</p>
        <common-buttons>
            <common-button
                :label="$t('common.microcopy.back_to_home')"
                :route="{ name: 'index' }"
                type="primary"
                size="large"
            ></common-button>
        </common-buttons>
    </div>
</template>

<script>
    import CheckboxInput from 'components/form-inputs/CheckboxInput'
    import TextInput from 'components/form-inputs/TextInput.vue'
    import cloneDeep from 'lodash.clonedeep'

    export default {
        components: {
            CheckboxInput,
            TextInput,
        },

        props: {
            ancillaryServices: { type: Array, required: true },
            showHeader: { type: Boolean, default: true },
            prefillValues: { type: Array, default: () => [] },
        },

        data() {
            return {
                checkedValues: [],
                ancillaryServicesFiltered: [],
            }
        },

        methods: {
            getAncillaryIcon(key) {
                switch (key) {
                    case 1:
                        return 'ancillary-diagnostic'
                    case 2:
                        return 'ancillary-therapeutic'
                    case 3:
                        return 'ancillary-custodial'
                }
            },

            checked(id) {
                return this.checkedValues.map((item) => item.id).includes(id)
            },

            selectionChanged(item) {
                if (this.checkedValues.map((item) => item.id).includes(item.id)) {
                    this.checkedValues.splice(this.checkedValues.map((item) => item.id).indexOf(item.id), 1)
                } else {
                    this.checkedValues.push(item)
                }
            },

            saveChanges() {
                this.emitEvent({ name: 'ancillary-selection-save', payload: this.checkedValues })
            },

            setPrefillValues() {
                this.checkedValues = cloneDeep(this.prefillValues)
            },

            filter(event, service, serviceTypeIndex, serviceIndex) {
                const activeService = this.ancillaryServices[serviceTypeIndex].facilityServiceTypes[serviceIndex]

                service.facilityServiceTypesGroups = activeService.facilityServiceTypesGroups.map((group) => {
                    return {
                        ...group,
                        facilityServiceTypesSubgroups: group.facilityServiceTypesSubgroups.map((subGroup) => {
                            return {
                                ...subGroup,
                                facilityServiceTests: subGroup.facilityServiceTests.filter((test) =>
                                    test.name.toLowerCase().includes(event.toLowerCase()),
                                ),
                            }
                        }),
                    }
                })
            },

            checkIfAnyTestExist(group) {
                return !group.facilityServiceTypesSubgroups.some((subGroup) => subGroup.facilityServiceTests.length)
            },
        },

        watch: {
            prefillValues() {
                this.setPrefillValues()
            },

            ancillaryServices() {
                this.ancillaryServicesFiltered = cloneDeep(this.ancillaryServices)
            },
        },

        mounted() {
            this.setPrefillValues()
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/page-elements/ancillary-table/_ancillary-table';
</style>
